module.exports = __webpack_public_path__ + "assets/images/project/bannerimage/bannerimage-desktop.jpg?v=55a8161e";